import { h, Fragment } from "preact";
import { useParams } from "react-router-dom";
import { BookingWidget } from "../components/booking-widget/BookingWidget";

export default function BookingPage() {
  const { businessId } = useParams<{ businessId: string }>();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-slate-900 p-4">
      {businessId ? (
        <BookingWidget businessId={businessId} />
      ) : (
        // Handle case where businessId is missing from URL (shouldn't happen with proper routing)
        <div className="text-center p-8 bg-white dark:bg-slate-800 rounded-lg shadow-md">
          <h1 className="text-xl font-semibold text-red-600">Error</h1>
          <p className="text-gray-600 dark:text-gray-300 mt-2">
            Business ID not found in URL.
          </p>
        </div>
      )}
    </div>
  );
}
